import { useContext } from 'react';
import Context from './Context';
export { default } from './Provider';
export * from './define';
export { default as withScheduleEvent } from './with';

export function useScheduleEvent() {
    return useContext(Context);
}
